module.exports = __webpack_public_path__ + "assets/img/not-good.7008d07f.png";